import { useEffect, useState } from "react";
import { useLensApp } from "../useLensApp.jsx";

export default function RemoteControlSection() {
  const { settings, actions } = useLensApp();
  const [room, setRoom] = useState(settings?.remoteControlRoom || "default");
  const [enabled, setEnabled] = useState(settings?.remoteControlEnabled === false ? "false" : "true");

  useEffect(() => setRoom(settings?.remoteControlRoom || "default"), [settings?.remoteControlRoom]);
  useEffect(() => setEnabled(settings?.remoteControlEnabled === false ? "false" : "true"), [settings?.remoteControlEnabled]);

  const save = () => actions.saveRemoteControlSettings({
    remoteControlEnabled: enabled === "true",
    remoteControlRoom: room.trim() || "default",
  }).catch(actions.setError);

  return (
    <section>
      <h3>Remote Control</h3>
      <div className="field">
        <label htmlFor="remoteControlEnabledInput">DO relay</label>
        <select id="remoteControlEnabledInput" value={enabled} onChange={(event) => setEnabled(event.target.value)}>
          <option value="true">On</option>
          <option value="false">Off</option>
        </select>
      </div>
      <div className="field">
        <label htmlFor="remoteControlRoomInput">Room</label>
        <input id="remoteControlRoomInput" value={room} onChange={(event) => setRoom(event.target.value)} />
      </div>
      <div className="button-row"><button className="primary" onClick={save}>Save</button></div>
      <div className="hint">Device target: {settings?.remoteControlDeviceId ? `${settings.remoteControlDeviceId}:runtime` : "initializing"}</div>
    </section>
  );
}
